export const CHANGE_SPINE_BACKGROUND_COLOR = 'CHANGE_SPINE_BACKGROUND_COLOR';
export const CHANGE_SPINE_COLOR = 'CHANGE_SPINE_COLOR';
export const LOAD_SPINE_DEFAULTS = 'LOAD_SPINE_DEFAULTS';
export const CHANGE_SPINE_TEXT = 'CHANGE_SPINE_TEXT';
export const CHANGE_FONT_SIZE = 'CHANGE_FONT_SIZE';
export const CHANGE_FONT_FAMILY = 'CHANGE_FONT_FAMILY';
export const LOAD_COVER_DETAILS_BY_BOOK_ID = 'LOAD_COVER_DETAILS_BY_BOOK_ID';



// WEBPACK FOOTER //
// ./src/redux/action-types/entities/cover.js